import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { MenuRegenerationService } from 'src/app/services/menu-regeneration.service';
import { WhiteLabelService } from 'src/app/services/white-label.service';
import { DEFAULT_MENU_VERSION, MenuVersionEnum } from '../constants/menu-version.enum';

/**
 * Selecciona el shell de navegación (v1 legacy vs v2 segmentado).
 * superUser (Munily) siempre usa v1; el resto según white label del PH.
 */
@Component({
  selector: 'app-menu-shell',
  templateUrl: './menu-shell.component.html',
})
export class MenuShellComponent implements OnInit, OnDestroy {
  public menuVersion: MenuVersionEnum = DEFAULT_MENU_VERSION;
  public readonly MenuVersionEnum = MenuVersionEnum;
  private regenerationSubscription?: Subscription;

  constructor(
    private dataService: DataService,
    private whiteLabelService: WhiteLabelService,
    private menuRegenerationService: MenuRegenerationService,
  ) {}

  ngOnInit(): void {
    this.resolveMenuVersion();
    this.regenerationSubscription = this.menuRegenerationService.menuRegeneration$.subscribe(() => {
      this.resolveMenuVersion();
    });
  }

  ngOnDestroy(): void {
    this.regenerationSubscription?.unsubscribe();
  }

  private resolveMenuVersion(): void {
    const user = this.dataService.getUser();
    if (user?.superUser) {
      this.menuVersion = MenuVersionEnum.V1;
      return;
    }
    const building = this.dataService.getBuilding();
    this.menuVersion = this.whiteLabelService.getMenuVersion(building);
  }
}
